import { render } from "./FooterBanner.vue?vue&type=template&id=672bd3da"
import script from "./FooterBanner.vue?vue&type=script&lang=js"
export * from "./FooterBanner.vue?vue&type=script&lang=js"

import "./FooterBanner.vue?vue&type=style&index=0&id=672bd3da&lang=scss"
script.render = render

export default script